export const selectors = {
	elEditWrapper: '.lp-certificate-edit-wrapper',
	elTemplateItem: '.lp-cert-template-item',
	elLayoutSelection: '.lp-cert-layout-selection-wrapper',
	elLayoutBuilder: '.lp-cert-layout-builder-wrapper',
	elMenuItem: '.lp-cert-builder-menu-item',
	elInserterItem: '.lp-inserter-item',
	elInserterElement: '.lp-cert-inserter-item[data-insert]',
	elInserterUploadArea: '.lp-inserter-upload-area',
	elInserterUploadGrid: '.lp-inserter-upload-grid',
	elInserterUploadBtn: '.lp-inserter-upload-btn',
	elInserterUploadItem: '.lp-inserter-upload-item',
	elInserterUploadLoadMore: '.lp-inserter-upload-load-more',
	elBackgroundColorSwatch: '.lp-background-color-swatch',
	elBackgroundColorInput: '.lp-background-color-input',
	elBackgroundBgItem: '.lp-background-bg-item',
	elBackgroundBgLoadMore: '.lp-background-bg-load-more',
	elBackgroundMainView: '.lp-background-main-view',
	elBackgroundBgMainGrid: '.lp-background-bg-section .lp-background-bg-grid',
	elGroupHeader: '.lp-cert-inserter-group-header',
	elSidebarTools: '.lp-cert-builder-sidebar-tools',
	elCanvas: '#lp-cert-builder-canvas',
	elBtnOpenFullscreen: '.lp-btn-cert-builder-open-full-screen',
	elBtnCloseFullscreen: '.lp-btn-cert-builder-close-full-screen',
	elBtnUndo: '.lp-btn-cert-undo',
	elBtnRedo: '.lp-btn-cert-redo',
	elTemplateApplyItem: '.lp-cert-template-apply-item',
	elBtnChooseTemplateFirst: '.lp-btn-cert-choose-template-first',
	elLibraryImagesViewAll: '.lp-library-images-view-all',
	elLibraryImagesBack: '.lp-library-images-back',
	elLibraryImageItem: '.lp-library-image-item',
	elLibraryMainView: '.lp-library-main-view',
	elLibraryFullView: '.lp-library-full-view',
	elBtnPreview: '.lp-btn-cert-preview',
	elPreviewModal: '.lp-cert-preview-modal',
	elPreviewModalClose: '.lp-cert-preview-modal__close',
	elPreviewCanvas: '#lp-cert-preview-canvas',
	elPreviewApply: '.lp-cert-preview-apply',
	elPreviewClear: '.lp-cert-preview-clear',
	elPreviewDownload: '.lp-cert-preview-download',
	elPreviewFields: '.lp-cert-preview-fields',
};

